<template>
  <div
    class="card shadow chart-type-card"
    :class="{
      'chart-type-selected': this.currentDisplayType == this.chartType,
      'chart-type-disabled': disabled
    }"
    @click="setDisplayType"
  >
    <div v-if="isCompetitiveProfileByNeed">
      <img src="/img/arrow-down-wide-short-duotone-solid.svg" width="26" class="w-support-card-type" alt="wRatings" />   
    </div>
    <div v-if="isCompetitiveProfileByWizard">
      <img src="/img/wizard-hat.svg" width="26" class="w-support-card-type" alt="wRatings" />
    </div>
    <div v-if="isCompetitiveProfileByMoat">
      <img src="/img/castle-duotone-solid.svg" width="26" class="w-support-card-type" alt="wRatings" />   
    </div>
    <div v-if="isCompetitiveProfileByValue">
      <img src="/img/scale-unbalanced-duotone-solid.svg" width="26" class="w-support-card-type" alt="wRatings" />   
    </div>
    <div v-if="isCompetitiveProfileByValueRoadmap">
      <img src="/img/road-duotone-solid.svg" width="26" class="w-support-card-type" alt="wRatings" />
    </div>
    <div v-if="isRoadmapExplore">
      <img src="/img/magnifying-glass-dollar.svg" width="26" class="w-support-card-type" alt="wRatings" />
    </div>
    <div v-if="isRoadmapPredictive">
      <img src="/img/hand-holding-circle-dollar-duotone-solid.svg" width="26" class="w-support-card-type" alt="wRatings" />
    </div>
    <div v-if="isMoatRank">
      <img src="/img/moneyball-ranks.png" class="moneyball-support-card-type" alt="wRatings" />
    </div>
    <div v-if="isWScoresRank">
      <img src="/img/wRatings-2021-W-support.png" class="w-support-card-type" alt="wRatings" />
    </div>
    <div v-if="isCompetitiveProfileByMoneyballStick">
      <img src="/img/moneyball.png" class="moneyball-support-card-type" alt="wRatings" />
    </div>
    <div v-if="isEmotionsRank">
<!--
      <i class="fa-duotone fa-heart-pulse" style="color: #960000; font-size: 23px;"></i>
-->      
<!--
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="55%">
        <path fill="#2f5eb3" stroke="#2f5eb3" class="fa-secondary" opacity=".4" d="M0 185.1l0 5.8c0 17.3 3 34.3 8.7 50.2c2.3-.7 4.8-1.1 7.3-1.1l106.7 0c3.2 0 6.1-1.9 7.4-4.9l31.8-76.3c3.7-8.8 12.3-14.6 21.8-14.8s18.3 5.4 22.2 14.1l51.3 113.9 41.4-82.8c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3l23.2 46.3c1.4 2.7 4.1 4.4 7.2 4.4l132 0c5.4-15.6 8.3-32.2 8.3-49.1l0-5.8c0-69.9-50.5-129.5-119.4-141c-7.8-1.3-15.7-1.9-23.5-1.9C331.5 42.2 295 57 268 84L256 96 244 84c-27-27-63.5-41.9-101.1-41.9c-7.8 0-15.7 .6-23.5 1.9C50.5 55.6 0 115.2 0 185.1zM35.7 288c3.7 4.3 7.7 8.5 11.9 12.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c4.2-3.9 8.2-8.1 11.9-12.4l-104.5 0c-21.2 0-40.6-12-50.1-31l-1.7-3.4-42.5 85.1c-4.1 8.3-12.7 13.5-22 13.3s-17.6-5.7-21.4-14.1L184.8 228.4l-10.5 25.2c-8.7 20.9-29.1 34.5-51.7 34.5l-87 0z"/>
        <path fill="#2f5eb3" stroke="#2f5eb3" class="fa-primary" d="M35.7 288l87 0c22.6 0 43-13.6 51.7-34.5l10.5-25.2 49.3 109.5c3.8 8.5 12.1 14 21.4 14.1s17.8-5 22-13.3L320 253.7l1.7 3.4c9.5 19 28.9 31 50.1 31l104.5 0c12.1-14.2 21.4-30.5 27.4-48l-132 0c-3 0-5.8-1.7-7.2-4.4l-23.2-46.3c-4.1-8.1-12.4-13.3-21.5-13.3s-17.4 5.1-21.5 13.3l-41.4 82.8L205.9 158.2c-3.9-8.7-12.7-14.3-22.2-14.1s-18.1 5.9-21.8 14.8l-31.8 76.3c-1.2 3-4.2 4.9-7.4 4.9L16 240c-2.6 0-5 .4-7.3 1.1c6.1 17 15.2 32.9 27 46.9z"/>
      </svg>      
-->      
      <img src="/img/heart-pulse-duotone-solid.svg" width="26" class="w-support-card-type" alt="wRatings" />
    </div>
    <div v-if="isSatisfactionRank">
<!--
      <i class="fa-duotone fa-arrow-up-9-1" style="color: #C76829; font-size: 23px;"></i>
-->      
<!--
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="65%">
        <path fill="#C76829" stroke="#2f5eb3" class="fa-secondary" opacity=".4" d="M344 120c0 39.2 25.6 72.4 61.1 83.8l-6.8 9.2c-10.5 14.2-7.5 34.2 6.7 44.8s34.2 7.5 44.8-6.7l48.8-65.8c14-18.9 21.5-41.7 21.5-65.2c0-48.6-39.4-88-88-88s-88 39.4-88 88zm8 328c0 17.7 14.3 32 32 32l48 0 48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0 0-96c0-10.3-4.9-19.9-13.3-26s-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2 0 51.6-16 0c-17.7 0-32 14.3-32 32zM464 120a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"/>
        <path fill="#C76829" stroke="#2f5eb3" class="fa-primary" d="M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3 192 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-301.7L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32z"/>
      </svg>      
-->      
      <img src="/img/arrow-up-9-1-duotone-solid.svg"  class="w-support-card-type" alt="wRatings" />              
    </div>
    <div v-if="isCompetitiveProfileByNps">
<!--
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"  width="60%">
        <path fill="#379660" stroke="#379660" class="fa-secondary" opacity=".4" d="M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm139.9 90.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5zM208.4 208a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm160 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"/>
        <path fill="#379660" stroke="#379660" class="fa-primary" d="M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"/>
      </svg>      
-->            
<!--
      <i class="fa-duotone fa-face-smile" aria-hidden="true"  style="font-size:23px;color: #379660"></i>
-->            
      <img src="/img/face-smile-duotone-solid.svg" width="26" class="w-support-card-type" alt="wRatings" />
    </div>
    <div v-if="isNPSRank">
<!--
      <i class="fa-duotone fa-face-viewfinder" aria-hidden="true"  style="font-size:23px;color: #379660"></i>
-->
<!--
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="55%">
        <path fill="#379660" stroke="#379660" class="fa-secondary" opacity=".4" d="M0 56C0 25.1 25.1 0 56 0l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L56 48c-4.4 0-8 3.6-8 8l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 56zM0 376c0-13.3 10.7-24 24-24s24 10.7 24 24l0 80c0 4.4 3.6 8 8 8l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-30.9 0-56-25.1-56-56l0-80zM352 24c0-13.3 10.7-24 24-24l80 0c30.9 0 56 25.1 56 56l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-4.4-3.6-8-8-8l-80 0c-13.3 0-24-10.7-24-24zm0 464c0-13.3 10.7-24 24-24l80 0c4.4 0 8-3.6 8-8l0-80c0-13.3 10.7-24 24-24s24 10.7 24 24l0 80c0 30.9-25.1 56-56 56l-80 0c-13.3 0-24-10.7-24-24z"/>
        <path fill="#379660" stroke="#379660" class="fa-primary" d="M256 416a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM200 192a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm88 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-95.5 76.9C208.5 309.6 231 320 256 320s47.5-10.4 63.5-27.1c6.1-6.4 16.2-6.6 22.6-.5s6.6 16.2 .5 22.6C320.8 337.8 290 352 256 352s-64.8-14.2-86.6-36.9c-6.1-6.4-5.9-16.5 .5-22.6s16.5-5.9 22.6 .5z"/>
      </svg>      
-->
      <img src="/img/face-viewfinder-duotone-solid.svg" width="26" class="w-support-card-type" alt="wRatings" />

    </div>
    <div :class="getChartCardClass()">
      {{ displayName }} <span v-if="isWScoresRank">&#174;</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "ChartTypeCard",
  mixins: [],
  components: {},
  data() {
    return {};
  },
  props: {
    currentDisplayType: {
      type: String,
      default: ""
    },
    chartType: {
      type: String,
      default: ""
    },
    displayName: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isCompetitiveProfileByWizard() {
      return this.chartType == "sales-wizard";
    },
    isCompetitiveProfileByNeed() {
      return this.chartType == "need";
    },
    isCompetitiveProfileByMoat() {
      return this.chartType == "moat";
    },
    isCompetitiveProfileByWinners() {
      return this.chartType == "winners";
    },
    isCompetitiveProfileByValueRoadmap() {
      return this.chartType == "value-roadmap";
    },
    isRoadmapExplore() {
      return this.chartType == "roadmap-explore";
    },
    isRoadmapPredictive() {
      return this.chartType == "roadmap-predictive";
    },
    isCompetitiveProfileByMoneyballStick() {
      return this.chartType == "moneyball-stick";
    },
    isCompetitiveProfileByNps() {
      return this.chartType == "nps";
    },
    isCompetitiveProfileByValue() {
      return this.chartType == "value";
    },
    isMoatRank() {
      return this.chartType == "moat-rank";
    },
    isWScoresRank() {
      return this.chartType == "w-scores-rank";
    },
    isEmotionsRank() {
      return this.chartType == "emotions-rank";
    },
    isSatisfactionRank() {
      return this.chartType == "satisfaction-rank";
    },
    isNPSRank() {
      return this.chartType == "nps-rank";
    },
    isMoatTrends() {
      return this.chartType == "trends";
    },    
    isResponseRates() {
      return this.chartType == "response-rates";
    },    
  },
  mounted() {},
  created() {},
  methods: {
    setDisplayType() {
      if (!this.disabled) {
        this.$emit("select", this.chartType);
      }
    },
    getChartCardClass() {
      let returnClassName = "chart-card-row chart-card-name ";
      if (this.isRoadmapExplore){
        returnClassName += "roadmap-explore-card";
      } else if (this.isRoadmapPredictive){
        returnClassName += "roadmap-predictive-card";
      } else if (this.isCompetitiveProfileByValueRoadmap){
        returnClassName += "competitive-profile-by-value-roadmap-card";
      } else if (this.isCompetitiveProfileByWizard) {
        returnClassName += "competitive-profile-by-wizard-card";
      } else if (this.isCompetitiveProfileByMoneyballStick) {
        returnClassName += "competitive-profile-by-moneyball-stick-card";
      } else if (this.isResponseRates){
        returnClassName += "response-rates-card";
      }else if (this.isCompetitiveProfileByWinners) {
        returnClassName += "competitive-profile-by-winners-card";
      } else if (this.isCompetitiveProfileByNeed) {
        returnClassName += "competitive-profile-by-need-card";
      } else if (this.isCompetitiveProfileByMoat) {
        returnClassName += "competitive-profile-by-moat-card";
      } else if (this.isCompetitiveProfileByValue) {
        returnClassName += "competitive-profile-by-value-card";
      } else if (this.isMoatRank) {
        returnClassName += "moat-rank";
      } else if (this.isMoatTrends) {
        returnClassName += "moat-trends-card";
      } else if (this.isWScoresRank) {
        returnClassName += "w-scores-rank-card";
      } else if (this.isEmotionsRank) {
        returnClassName += "emotions-rank-card";
      } else if (this.isSatisfactionRank) {
        returnClassName += "satisfaction-rank-card";
      } else if (this.isNPSRank) {
        returnClassName += "nps-rank-card";
      } else if (this.isCompetitiveProfileByNps) {
        returnClassName += "competitive-profile-by-word-cloud-card";
      }
      return returnClassName;
    }
  },
  watch: {}
};
</script>
